import {Component, Input} from "@angular/core";

@Component({
    selector: "wbo-localisation-indicator",
    styleUrls: ["./localisation-indicator.component.scss"],
    templateUrl: "./localisation-indicator.component.html"
})
export class LocalisationIndicatorComponent {
    @Input() height: number;
    @Input() isLocalised: boolean;
    @Input() width: number;

    constructor() {

    }
}
